import api from "./api"
export default {
	/**
     * Gets a list of notifications
     * @param {number} offset 
     * @param {number} limit 
     */
	async getBillingPortalURL() {
		let value = await api.get(`/billing/portal`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		let url = data.url
		return url
	},
	async postBillingPortalURL() {
		let value = await api.post(`/billing/postportal`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		let url = data.url
		return url
	},
	async join(name, email) {
		let value = await api.post(`/billing/join`, {name, email})
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	},

	async upgradePackages(currentPlan, payment, submitTime, expireDate, selectedPlan) {
		let value = await api.post(`/billing/packages/`, {
			currentPlan: currentPlan,
			payment: payment,
			submitTime: submitTime,
			expireDate: expireDate,
			selectedPlan: selectedPlan
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			console.log(error)
			throw error
		}
		let data = value.data.data[0]
		return data
	},

	async getUpgradePackages() {
		let value = await api.get(`/billing/packages/`)
		if (!value || !value.data || !value.data.error) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		
		let data = value.data.data
		return data
	},
	async getPaymentData(sessionId, clientID, priceCategory, Email, CurrentPlan, PriceofPlan, SubmitTime, ExpireTime, SelectedPlan) {
		let value = await api.get(`/ProductPlan/success`,{params:{sessionId:sessionId, clientID:clientID, priceCategory:priceCategory, Email:Email, CurrentPlan:CurrentPlan, PriceofPlan:PriceofPlan, SubmitTime:SubmitTime, ExpireTime:ExpireTime, SelectedPlan:SelectedPlan}})
		if (!value || !value.data || !value.data.error) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		
		let data = value.data.data
		return data
	},
}
